// Colocated Driver.js tour for the My Requests page, targeted at any
// wallet holder on first visit. Four steps, no FAQ outro: by the time a
// viewer reaches My Requests they will have already seen the outro at
// the end of their first-login tour (MyWalletDashboard chains into
// MyActivity, which closes with the outro). Kept short by design: the
// tour lands the viewer on the New Request button and the list, and
// lets them discover the per-row Cancel and filter details naturally.

export const MY_REQUESTS_OVERVIEW_TOUR_ID = 'my-requests-overview-v1';

export const buildMyRequestsOverviewTourSteps = () => [
    {
        element: '[data-tour="my-requests-card"]',
        title: 'When your limit is not enough',
        description: 'Sometimes you need to spend more than your daily, weekly, monthly, or per-transaction limit lets you. This is where you ask an admin to bump it up. Every request you send lives here until it is approved, rejected, or you cancel it.',
        side: 'bottom',
        align: 'center',
    },
    {
        element: '[data-tour="my-requests-new-request-button"]',
        title: 'Start a request',
        description: 'Tap New Request and we will open a short form: pick which of your limits to extend, tell us why, and set the new maximum you need. Your team reviewer gets emailed the moment you submit.',
        side: 'bottom',
        align: 'end',
    },
    {
        element: '[data-tour="my-requests-filters"]',
        title: 'Dig up an old one',
        description: 'Search for a specific reason, flip between Pending, Approved, and Rejected, or narrow to a date range. New ones always sit at the top of Pending until a reviewer decides.',
        side: 'bottom',
        align: 'start',
    },
    {
        element: '[data-tour="my-requests-list"]',
        title: 'Follow what happens next',
        description: 'Each row shows what you asked for, why, and where it stands. A pending row keeps a Cancel button so you can withdraw the request while it is still under review. Once a decision lands, you can see who reviewed it and, for rejections, the reason they gave.',
        side: 'top',
        align: 'center',
    },
];
